export class UpdateProfileDto {
  phone: string;
  idi: number;
  email?: string;
  data_nascimento?: string;
  clientId?: number;
  constructor(phone: string, idi: number, email: string, data_nascimento?: string, clientId?: number) {
    this.phone = phone;
    this.idi = idi;
    if (email) this.email = email;
    if (data_nascimento) this.data_nascimento = data_nascimento;
    if (clientId) this.clientId = clientId;
  }
}
